import firebase from "firebase";


const firebaseConfig = {
    apiKey: "AIzaSyAjQzMyPOKdfKqohEI4eLHmtxUXXTegVlg",
    authDomain: "mglinked-clone.firebaseapp.com",
    projectId: "mglinked-clone",
    storageBucket: "mglinked-clone.appspot.com",
    messagingSenderId: "780427563301",
    appId: "1:780427563301:web:cea7c4c722dc6d7a86cacc"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage();

export { auth, provider, storage };
export default db;